module.exports = __webpack_public_path__ + "static/media/bengtsforsvapen.92061742.png";